import { useTags } from '../hooks/useTags';
import type { TagOption } from '../types/Tag';
import { MultiSearchCombobox, type MultiSearchComboboxProps } from './MultiSearchCombobox';

type TagsComboboxProps = Omit<
  MultiSearchComboboxProps<TagOption, TagOption>,
  'useSearch' | 'toOption' | 'renderMarker'
>;

const toTag = (tag: TagOption) => tag;

export function TagsCombobox(props: TagsComboboxProps) {
  return (
    <MultiSearchCombobox
      {...props}
      useSearch={useTags}
      toOption={toTag}
      renderMarker={(tag) => (
        <span
          aria-hidden="true"
          className="inline-block h-2 w-2 shrink-0 rounded-full"
          style={{ backgroundColor: tag.color }}
        />
      )}
    />
  );
}
